const sizePx = {
  5: '5px',
  50: '50px',
  100: '100px',
  borderRadius: '6px',
  margin: '12px',
  paddingS: '10px',
  paddingM: '20px',
  paddingG: '40px',
  paddingButton: '10px 20px',
  icon24: '24px',
  icon30: '30px',
  icon80: '80px',
  icon100: '100px',
  icon150: '150px',
  icon300: '300px',
  modalWidthS: '350px',
  modalWidthM: '480px',
  modalHeightS: '500px',
  modalHeight: '560px'
};

export default sizePx;
